import React, { useEffect, useState } from 'react';
import { Crown, Menu, X, ExternalLink, Send } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Featured',
    href: '#featured'
  }, {
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'Reviews',
    href: '#reviews'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="flex justify-between items-center" data-id="element-145">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-id="element-146">
            <div className="bg-gold p-1.5 rounded-full text-white group-hover:scale-110 transition-transform duration-300" data-id="element-147">
              <Crown size={20} fill="currentColor" data-id="element-148" />
            </div>
            <div className="flex flex-col" data-id="element-149">
              <span className={`font-serif font-bold text-lg leading-none ${isScrolled ? 'text-forest' : 'text-forest'}`} data-id="element-150">
                sgbeautycastle
              </span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8" data-id="element-151">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-stone hover:text-gold font-medium transition-colors duration-200 text-sm tracking-wide" data-id="element-152">
                {link.name}
              </a>)}
            <a href="https://www.geylang777-2.site" target="_blank" rel="noopener noreferrer" className="bg-gold hover:bg-gold-dark text-white px-5 py-2 rounded-full text-sm font-medium transition-colors duration-300 shadow-lg shadow-gold/20 flex items-center gap-2" data-id="element-153">
              <ExternalLink size={16} data-id="element-154" />
              中文网站入口
            </a>
            <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="bg-[#229ED9] hover:bg-[#1a8abf] text-white px-5 py-2 rounded-full text-sm font-medium transition-colors duration-300 shadow-lg shadow-[#229ED9]/20 flex items-center gap-2" data-id="element-155">
              <Send size={16} data-id="element-156" />
              Telegram
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-forest p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-157">
            {isMobileMenuOpen ? <X size={24} data-id="element-158" /> : <Menu size={24} data-id="element-159" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-160">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-cream border-t border-stone/10 overflow-hidden" data-id="element-161">
            <div className="px-4 py-6 space-y-4 flex flex-col items-center" data-id="element-162">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-forest text-lg font-medium hover:text-gold transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-163">
                  {link.name}
                </a>)}
              <a href="https://www.geylang777-2.site" target="_blank" rel="noopener noreferrer" className="w-full bg-gold text-white py-3 rounded-lg font-medium mt-4 block text-center" data-id="element-164">
                中文网站入口
              </a>
              <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="w-full bg-[#229ED9] text-white py-3 rounded-lg font-medium mt-2 block text-center" data-id="element-165">
                Telegram 电报频道
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}